import React from "react";
import styles from "./carsBar.module.scss";
import SideBarInner from "../../../shared/sideBarInner";
import SideBarControl from "../../sides/sideBarControl";
import ControlsTitleClosedBar from "../reports/controlsTitleClosedBar";
import TitleBarWrapper from "../../../shared/titleBarWrapper";
import FirstTitle from "../../../shared/items/static/firstTitle";
import ControlList from "../../Controls/ControlList/ControlList";

const ControlBar = () => {
  return (
    <div className={styles.sideBarsWrapper}>
      <SideBarControl TitleClosed={<ControlsTitleClosedBar />}>
        <div className={styles.reportsBar}>
          <SideBarInner>
            <TitleBarWrapper>
              <FirstTitle>Управление</FirstTitle>
            </TitleBarWrapper>
          </SideBarInner>
          <ControlList />
        </div>
      </SideBarControl>
    </div>
  );
};

export default React.memo(ControlBar);
